"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ExternalContext = /*#__PURE__*/_react["default"].createContext({
  externalSettings: {}
});
var _default = ExternalContext;
exports["default"] = _default;